import { FC, useState } from "react";
import { Button, Divider, message } from "antd";
import { Card, CardBody, Typography } from "../material-old";
import { useAppSelector } from "../../redux/hooks";
import { FolderAddFilled } from "@ant-design/icons";
import { DateFilter } from "../folders/DateFilter"; // Removed .tsx extension
import { FilterSortDropdown } from "../folders/FilterSortDropdown"; // Removed .tsx extension
import { CreateRecordModal } from "../folders/CreateRecordModal";

export const Header: FC = () => {
  const [_, contextHolder] = message.useMessage();
  const { results } = useAppSelector((state) => state.folder);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const onCreateRecord = () => {
    setIsCreateModalOpen(true);
  };

  return (
    <>
      <Card className={`w-full mx-auto`}>
        {contextHolder}
        <CardBody className="flex flex-col justify-center items-center">
          <div className="w-full flex justify-between items-center">
            <div className="w-2/3 flex flex-col items-start">
              <Typography variant="h4" color="blue-gray" className="mb-1">
                Mis Expedientes
              </Typography>
              <div className="text-gray-600">
                En esta sección podrás visualizar y gestionar tus expedientes
                asignados.
              </div>
            </div>
            <div style={{ fontSize: "0.925rem" }}>
              <Button
                type="primary"
                size="large"
                onClick={onCreateRecord}
                icon={<FolderAddFilled />}
                className="px-4 py-2 "
              >
                <span>Crear expediente</span>
              </Button>
            </div>
          </div>
          <Divider orientation="left"></Divider>
          <div className="flex flex-wrap justify-end space-x-8">
            <div>
              <DateFilter />
            </div>
            <div>
              <FilterSortDropdown
                type="filter"
                isMyFoldersView
                includeSpecialFilters
              />
            </div>
            <div>
              <FilterSortDropdown type="filter" isMyFoldersView />
            </div>
            <div>
              <FilterSortDropdown type="sort" isMyFoldersView />
            </div>
          </div>
          <Divider orientation="left"></Divider>
          <div className="w-full flex text-sm">
            <span className="ml-auto">
              Expedientes encontrados: <b>{results.length}</b>
            </span>
          </div>
        </CardBody>
      </Card>
      <CreateRecordModal
        isOpen={isCreateModalOpen}
        onOpenChange={setIsCreateModalOpen}
      />
    </>
  );
};
